import * as React from 'react';

import NextImage from 'next/image';

import fish from './fib-fish.svg';
import fishAnimation from './fish-animated.gif';
import styles from './LoadingIndicator.module.css';

interface LoadingIndicatorProps {
  textHeader?: string;
  textSubheader?: string;
  animated?: boolean;
}

export const LoadingIndicator = ({
  textHeader = '',
  textSubheader = '',
  animated = false,
}: LoadingIndicatorProps) => (
  <div className={styles.main} data-testid="LoadingIndicator">
    {animated ? (
      <NextImage
        alt="animated fish"
        src={fishAnimation.src}
        width={fishAnimation.width}
        height={fishAnimation.height}
        unoptimized
        className="mb-10"
      />
    ) : (
      <div className={styles.container}>
        <div className={styles.animation}>
          <div className={styles.image} style={{ backgroundImage: `url(${fish.src})` }} />
        </div>
      </div>
    )}
    {textHeader && (
      <span className="text-trench text-center text-lg font-semibold md:text-xl">{textHeader}</span>
    )}
    {textSubheader && (
      <span className="text-abyss mt-2 text-center font-normal">{textSubheader}</span>
    )}
  </div>
);
